// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2AQ7U","buttons":"RemoveExpirationActionButtons_buttons__1Pgkx"};